(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-family-root]').forEach(root => {
      if (root.dataset.heartReady) return;
      root.dataset.heartReady = 'true';
      const controls = [...root.querySelectorAll('[data-family-select]')];
      const panels = [...root.querySelectorAll('[data-family-panel]')];
      const select = key => {
        controls.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.familySelect === key)));
        panels.forEach(p => { p.hidden = p.dataset.familyPanel !== key; });
      };
      controls.forEach(b => b.addEventListener('click', () => select(b.dataset.familySelect)));
      if (controls.length) { select(controls[0].dataset.familySelect); root.querySelector('.family-selector').hidden = false; }
    });
    scope.querySelectorAll('[data-location-root]').forEach(root => {
      if (root.dataset.heartReady) return;
      root.dataset.heartReady = 'true';
      const controls = [...root.querySelectorAll('[data-location-select]')];
      const panels = [...root.querySelectorAll('[data-location-panel]')];
      const canvas = root.querySelector('[data-map]');
      const tiles = root.querySelector('[data-map-tiles]');
      const pinLayer = root.querySelector('[data-map-pins]');
      const loading = root.querySelector('[data-map-loading]');
      const error = root.querySelector('[data-map-error]');
      const dragToggle = root.querySelector('[data-map-drag]');
      const points = panels.map((p, i) => ({ name:p.dataset.name, lat:Number(p.dataset.lat), lng:Number(p.dataset.lng), label:String(i + 1).padStart(2, '0'), index:i }));
      points.push({name:'Hofbäckerei',lat:52.3959799,lng:9.76514,label:'H',href:'/#hofbaeckerei'},{name:'Fahrenhorst',lat:52.3755765,lng:9.7464597,label:'F',href:'/#fahrenhorst'});
      let zoom = 12, center = [52.3709,9.7276], enabled = false, ready = false, selected = 0, dragging = null;
      const mercator = (lat,lng,z) => {
        const scale = 256 * 2 ** z, sin = Math.sin(lat * Math.PI / 180);
        return [(lng + 180) / 360 * scale, (0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI)) * scale];
      };
      const inverse = (x,y,z) => {
        const scale = 256 * 2 ** z;
        return [Math.atan(Math.sinh(Math.PI * (1 - 2 * y / scale))) * 180 / Math.PI, x / scale * 360 - 180];
      };
      const pins = points.map(point => {
        const pin = document.createElement(point.href ? 'a' : 'button');
        pin.className = 'map-pin' + (point.href ? ' map-pin--house' : '');
        pin.textContent = point.label; pin.title = point.name; pin.setAttribute('aria-label', point.name);
        if (point.href) pin.href = point.href;
        else { pin.type = 'button'; pin.addEventListener('click', () => select(point.index, false)); }
        pinLayer.append(pin); return pin;
      });
      const render = () => {
        if (!ready || !canvas.clientWidth) return;
        const width = canvas.clientWidth, height = canvas.clientHeight, world = mercator(...center, zoom);
        const left = world[0] - width / 2, top = world[1] - height / 2;
        const wanted = new Set();
        const old = new Map([...tiles.children].map(img => [img.dataset.key, img]));
        let successes = 0, failures = 0;
        for (let x = Math.floor(left / 256); x <= Math.floor((left + width) / 256); x++) {
          for (let y = Math.floor(top / 256); y <= Math.floor((top + height) / 256); y++) {
            const key = `${zoom}/${x}/${y}`; wanted.add(key);
            let tile = old.get(key);
            if (!tile) {
              tile = new Image(); tile.alt = ''; tile.width = tile.height = 256; tile.dataset.key = key; tile.draggable = false;
              tile.onload = () => { successes++; loading.hidden = true; error.hidden = true; };
              tile.onerror = () => { failures++; loading.hidden = true; if (!successes && failures > 2) error.hidden = false; };
              tile.src = `https://tile.openstreetmap.org/${key}.png`; tiles.append(tile);
            }
            tile.style.left = `${Math.round(x * 256 - left)}px`; tile.style.top = `${Math.round(y * 256 - top)}px`;
          }
        }
        old.forEach((img,key) => { if (!wanted.has(key)) img.remove(); });
        points.forEach((p,i) => {
          const at = mercator(p.lat,p.lng,zoom);
          pins[i].style.left = `${at[0] - left}px`; pins[i].style.top = `${at[1] - top}px`;
          if (!p.href) pins[i].setAttribute('aria-pressed', String(p.index === selected));
        });
        root.querySelector('[data-map-zoom="1"]').disabled = zoom >= 17;
        root.querySelector('[data-map-zoom="-1"]').disabled = zoom <= 10;
      };
      function select(index, move = true) {
        selected = index;
        panels.forEach((p,i) => { p.hidden = i !== index; });
        controls.forEach((b,i) => b.setAttribute('aria-pressed', String(i === index)));
        if (move) { center = [points[index].lat,points[index].lng]; zoom = 14; }
        render();
      }
      const reset = () => {
        const coords = points.map(p => mercator(p.lat,p.lng,0));
        const xs = coords.map(p => p[0]), ys = coords.map(p => p[1]);
        const dx = Math.max(...xs) - Math.min(...xs), dy = Math.max(...ys) - Math.min(...ys);
        zoom = Math.min(12,Math.max(10,Math.floor(Math.log2(Math.min((canvas.clientWidth - 65)/dx,(canvas.clientHeight - 65)/dy)))));
        center = inverse((Math.max(...xs)+Math.min(...xs))/2,(Math.max(...ys)+Math.min(...ys))/2,0);
        render();
      };
      controls.forEach(b => b.addEventListener('click', () => select(Number(b.dataset.locationSelect))));
      root.querySelector('.location-tabs').hidden = false;
      root.querySelector('.location-panels').classList.add('is-ready');
      select(0, false);
      root.querySelector('[data-map-reset]').addEventListener('click', reset);
      root.querySelectorAll('[data-map-zoom]').forEach(b => b.addEventListener('click', () => { zoom = Math.max(10,Math.min(17,zoom + Number(b.dataset.mapZoom))); render(); }));
      dragToggle.addEventListener('click', () => {
        enabled = !enabled; canvas.classList.toggle('is-draggable',enabled); dragToggle.setAttribute('aria-pressed',String(enabled));
        dragToggle.textContent = enabled ? 'Verschieben beenden' : 'Karte verschieben aktivieren';
      });
      canvas.addEventListener('pointerdown', e => {
        if (!enabled || e.target.closest('button,a')) return;
        dragging = {x:e.clientX,y:e.clientY,world:mercator(...center,zoom)};canvas.setPointerCapture(e.pointerId);canvas.classList.add('is-dragging');
      });
      canvas.addEventListener('pointermove', e => {
        if (!dragging) return;
        center = inverse(dragging.world[0] - (e.clientX - dragging.x),dragging.world[1] - (e.clientY - dragging.y),zoom); render();
      });
      const end = () => { dragging = null; canvas.classList.remove('is-dragging'); };
      canvas.addEventListener('pointerup',end);canvas.addEventListener('pointercancel',end);
      if ('ResizeObserver' in window) new ResizeObserver(() => { if (ready) render(); }).observe(canvas);
      const consent = root.querySelector('[data-map-consent]');
      const load = root.querySelector('[data-map-load]');
      const stop = root.querySelector('[data-map-stop]');
      if (load && consent && stop) {
        load.addEventListener('click', () => {
          ready = true;
          consent.hidden = true;
          stop.hidden = false;
          loading.hidden = false;
          reset();
          stop.focus();
        });
        stop.addEventListener('click', () => {
          ready = false;
          enabled = false;
          tiles.replaceChildren();
          loading.hidden = true;
          error.hidden = true;
          stop.hidden = true;
          consent.hidden = false;
          canvas.classList.remove('is-draggable');
          dragToggle.setAttribute('aria-pressed', 'false');
          load.focus();
        });
      }
    });
    scope.querySelectorAll('[data-catering-planner]').forEach(form => {
      if (form.dataset.heartReady) return;
      form.dataset.heartReady = 'true';
      const number = form.querySelector('[data-guests-number]');
      const range = form.querySelector('[data-guests-range]');
      range.addEventListener('input', () => { number.value = range.value; });
      number.addEventListener('input', () => { range.value = number.value; });
    });
    const params = new URLSearchParams(location.search);
    const occasion = params.get('anlass');
    if (occasion) scope.querySelectorAll('select[name="contact[Anlass]"]').forEach(select => {
      if (!select.value) select.value = occasion === 'business' ? 'Firmenfrühstück / Meeting' : occasion === 'privat' ? 'Private Feier' : '';
    });
    const guests = Number(params.get('gaeste'));
    if (Number.isInteger(guests) && guests > 0 && guests < 100000) scope.querySelectorAll('input[name="contact[Gaestezahl]"]').forEach(input => { if (!input.value) input.value = guests; });
    const meals = {fruehstueck:'Frühstück & Brunch',fingerfood:'Fingerfood & Snacks',buffet:'Warme Speisen & Buffet'};
    const meal = meals[params.get('speisen')];
    if (meal) scope.querySelectorAll('select[name="contact[Cateringwunsch]"]').forEach(select => { select.value = meal; });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

